/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Application } from '../models/Application';
import type { ApplicationCompleteness } from '../models/ApplicationCompleteness';
import type { ApplicationStatus } from '../models/ApplicationStatus';
import type { ApproveApplicationRequest } from '../models/ApproveApplicationRequest';
import type { BusinessStructure } from '../models/BusinessStructure';
import type { CancelApplicationResponse } from '../models/CancelApplicationResponse';
import type { CarrierDocumentType } from '../models/CarrierDocumentType';
import type { CreateApplicationNoteRequest } from '../models/CreateApplicationNoteRequest';
import type { CreateApplicationNoteResponse } from '../models/CreateApplicationNoteResponse';
import type { CreateApplicationRequest } from '../models/CreateApplicationRequest';
import type { CreateApplicationResult } from '../models/CreateApplicationResult';
import type { CreatedResult } from '../models/CreatedResult';
import type { CreateInsuranceRequest } from '../models/CreateInsuranceRequest';
import type { GetApplicationFeesResponse } from '../models/GetApplicationFeesResponse';
import type { GetClaimableCertificateResult } from '../models/GetClaimableCertificateResult';
import type { IActionResult } from '../models/IActionResult';
import type { ListApplicationNotesResponse } from '../models/ListApplicationNotesResponse';
import type { ListApplicationsResult } from '../models/ListApplicationsResult';
import type { MotorCarrierApplicationQueueSort } from '../models/MotorCarrierApplicationQueueSort';
import type { RegistrationPeriod } from '../models/RegistrationPeriod';
import type { RegistrationType } from '../models/RegistrationType';
import type { RejectApplicationRequest } from '../models/RejectApplicationRequest';
import type { SaferCarrier } from '../models/SaferCarrier';
import type { SetApplicationSelfInsuranceAmountRequest } from '../models/SetApplicationSelfInsuranceAmountRequest';
import type { SortDirection } from '../models/SortDirection';
import type { StoredDocument } from '../models/StoredDocument';
import type { SubmitApplicationRequest } from '../models/SubmitApplicationRequest';
import type { UpdateApplicationNoteRequest } from '../models/UpdateApplicationNoteRequest';
import type { UpdateApplicationRequest } from '../models/UpdateApplicationRequest';
import type { UpdateRegistrationPeriodRequest } from '../models/UpdateRegistrationPeriodRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApplicationService {
  /**
   * Validates USDOT + EIN and returns the unclaimed certificate details without granting access
   * @param usdot
   * @param ein
   * @returns GetClaimableCertificateResult OK
   * @throws ApiError
   */
  public static getClaimableCertificate(
    usdot: number,
    ein: string,
  ): CancelablePromise<GetClaimableCertificateResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/claimables',
      query: {
        'usdot': usdot,
        'ein': ein,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Creates applications for Certificate and Broker
   * @param requestBody
   * @returns CreateApplicationResult Created
   * @throws ApiError
   */
  public static createAsync(
    requestBody?: CreateApplicationRequest,
  ): CancelablePromise<CreateApplicationResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * List applications, filtering by various criteria. This is used for listing applications in the admin interface.
   * @param query
   * @param status
   * @param assignedTo
   * @param registrationType
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns ListApplicationsResult OK
   * @throws ApiError
   */
  public static listApplications(
    query?: string,
    status?: Array<ApplicationStatus>,
    assignedTo?: Array<string>,
    registrationType?: Array<RegistrationType>,
    limit?: number,
    offset?: number,
    sortBy?: MotorCarrierApplicationQueueSort,
    sortDirection?: SortDirection,
  ): CancelablePromise<ListApplicationsResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application',
      query: {
        'query': query,
        'status': status,
        'assignedTo': assignedTo,
        'registrationType': registrationType,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
    });
  }
  /**
   * Cancels applications
   * @param applicationId
   * @returns CancelApplicationResponse OK
   * @throws ApiError
   */
  public static cancelApplicationAsync(
    applicationId: string,
  ): CancelablePromise<CancelApplicationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/cancel',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Submits application for review
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static submitApplication(
    applicationId: string,
    requestBody?: SubmitApplicationRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/submit',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Reports which steps of the application wizard are complete and what is missing from the rest
   * @param applicationId
   * @returns ApplicationCompleteness OK
   * @throws ApiError
   */
  public static getApplicationCompleteness(
    applicationId: string,
  ): CancelablePromise<ApplicationCompleteness> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/completeness',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Gets the carrier's information from the application ID
   * @param applicationId
   * @returns SaferCarrier OK
   * @throws ApiError
   */
  public static getCarrierFromApplicationId(
    applicationId: string,
  ): CancelablePromise<SaferCarrier> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/carrier',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        409: `Conflict`,
      },
    });
  }
  /**
   * Gets a specific application by its ID.
   * @param applicationId
   * @returns Application OK
   * @throws ApiError
   */
  public static getApplication(
    applicationId: string,
  ): CancelablePromise<Application> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}',
      path: {
        'applicationId': applicationId,
      },
    });
  }
  /**
   * Update steps or assignee on the application
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static updateApplication(
    applicationId: string,
    requestBody?: UpdateApplicationRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Application/{applicationId}',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Approves an application, updating only the status to Approved
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static approveApplication(
    applicationId: string,
    requestBody?: ApproveApplicationRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/approve',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Unprocessable Content`,
      },
    });
  }
  /**
   * Sets, edits, or clears self-insurance on a pending application
   * @param applicationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static setApplicationSelfInsuranceAmount(
    applicationId: string,
    requestBody?: SetApplicationSelfInsuranceAmountRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Application/{applicationId}/self-insurance',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Unprocessable Content`,
      },
    });
  }
  /**
   * Rejects an application, updating the status to Rejected and saving notes
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static rejectApplication(
    applicationId: string,
    requestBody?: RejectApplicationRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/reject',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Unprocessable Content`,
      },
    });
  }
  /**
   * Create an application note for an application by its id.
   * @param applicationId
   * @param requestBody
   * @returns CreateApplicationNoteResponse Created
   * @throws ApiError
   */
  public static createApplicationNote(
    applicationId: string,
    requestBody?: CreateApplicationNoteRequest,
  ): CancelablePromise<CreateApplicationNoteResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/notes',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * List application notes for an application by its id.
   * @param applicationId
   * @returns ListApplicationNotesResponse OK
   * @throws ApiError
   */
  public static listApplicationNotes(
    applicationId: string,
  ): CancelablePromise<ListApplicationNotesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/notes',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Update an application note by its id.
   * @param applicationId
   * @param noteId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateApplicationNote(
    applicationId: string,
    noteId: number,
    requestBody?: UpdateApplicationNoteRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Application/{applicationId}/notes/{noteId}',
      path: {
        'applicationId': applicationId,
        'noteId': noteId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Delete an application note by its id.
   * @param applicationId
   * @param noteId
   * @returns void
   * @throws ApiError
   */
  public static deleteApplicationNote(
    applicationId: string,
    noteId: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Application/{applicationId}/notes/{noteId}',
      path: {
        'applicationId': applicationId,
        'noteId': noteId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Create insurance user to grant access to create insurance policy(ies) during carrier application flow(s)
   * @param requestBody
   * @returns CreatedResult Created
   * @throws ApiError
   */
  public static createInsuranceAsync(
    requestBody?: CreateInsuranceRequest,
  ): CancelablePromise<CreatedResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/insurance',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Save applications business information
   * @param applicationId
   * @param requestBody
   * @returns IActionResult OK
   * @throws ApiError
   */
  public static saveApplicationBusinessInfo(
    applicationId: string,
    requestBody?: BusinessStructure,
  ): CancelablePromise<IActionResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/business',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Able to skip registration step
   * @param applicationId
   * @param requestBody
   * @returns IActionResult OK
   * @throws ApiError
   */
  public static skipRegistrationPeriod(
    applicationId: string,
    requestBody?: boolean,
  ): CancelablePromise<IActionResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/registration-period/skip',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * @param applicationId
   * @returns RegistrationPeriod OK
   * @throws ApiError
   */
  public static getRegistrationPeriod(
    applicationId: string,
  ): CancelablePromise<RegistrationPeriod> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/registration-period',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * @param applicationId
   * @param requestBody
   * @returns IActionResult OK
   * @throws ApiError
   */
  public static updateRegistrationPeriod(
    applicationId: string,
    requestBody?: UpdateRegistrationPeriodRequest,
  ): CancelablePromise<IActionResult> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Application/{applicationId}/registration-period',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get motor carrier application fee details for a specific application.
   * @param applicationId
   * @returns GetApplicationFeesResponse OK
   * @throws ApiError
   */
  public static getApplicationFees(
    applicationId: string,
  ): CancelablePromise<GetApplicationFeesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/fees',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Upload a carrier application document to S3.
   * @param applicationId
   * @param documentType
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadCarrierDocument(
    applicationId: string,
    documentType: CarrierDocumentType,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/uploads/{documentType}',
      path: {
        'applicationId': applicationId,
        'documentType': documentType,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get carrier document metadata, if one exists, for a document type.
   * @param applicationId
   * @param documentType
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static getCarrierDocument(
    applicationId: string,
    documentType: CarrierDocumentType,
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/uploads/{documentType}',
      path: {
        'applicationId': applicationId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a carrier document for a document type.
   * @param applicationId
   * @param documentType
   * @returns void
   * @throws ApiError
   */
  public static deleteCarrierDocument(
    applicationId: string,
    documentType: CarrierDocumentType,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Application/{applicationId}/uploads/{documentType}',
      path: {
        'applicationId': applicationId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Stream a carrier document for preview or download.
   * @param applicationId
   * @param documentType
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadCarrierDocument(
    applicationId: string,
    documentType: CarrierDocumentType,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/uploads/{documentType}/content',
      path: {
        'applicationId': applicationId,
        'documentType': documentType,
      },
      query: {
        'download': download,
      },
    });
  }
  /**
   * Upload an ID document for a business partner to S3.
   * @param applicationId
   * @param partnerId
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadBusinessPartnerIdDocument(
    applicationId: string,
    partnerId: string,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/partners/{partnerId}/id-document',
      path: {
        'applicationId': applicationId,
        'partnerId': partnerId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get business partner ID document metadata, if one exists.
   * @param applicationId
   * @param partnerId
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static getBusinessPartnerIdDocument(
    applicationId: string,
    partnerId: string,
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/partners/{partnerId}/id-document',
      path: {
        'applicationId': applicationId,
        'partnerId': partnerId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a business partner's ID document.
   * @param applicationId
   * @param partnerId
   * @returns void
   * @throws ApiError
   */
  public static deleteBusinessPartnerIdDocument(
    applicationId: string,
    partnerId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Application/{applicationId}/partners/{partnerId}/id-document',
      path: {
        'applicationId': applicationId,
        'partnerId': partnerId,
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Stream a business partner's ID document for preview or download.
   * @param applicationId
   * @param partnerId
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadBusinessPartnerIdDocument(
    applicationId: string,
    partnerId: string,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/partners/{partnerId}/id-document/content',
      path: {
        'applicationId': applicationId,
        'partnerId': partnerId,
      },
      query: {
        'download': download,
      },
    });
  }
  /**
   * Upload an ID document for a business officer to S3.
   * @param applicationId
   * @param officerId
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadBusinessOfficerIdDocument(
    applicationId: string,
    officerId: string,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Application/{applicationId}/officers/{officerId}/id-document',
      path: {
        'applicationId': applicationId,
        'officerId': officerId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get business officer ID document metadata, if one exists.
   * @param applicationId
   * @param officerId
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static getBusinessOfficerIdDocument(
    applicationId: string,
    officerId: string,
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/officers/{officerId}/id-document',
      path: {
        'applicationId': applicationId,
        'officerId': officerId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a business officer's ID document.
   * @param applicationId
   * @param officerId
   * @returns void
   * @throws ApiError
   */
  public static deleteBusinessOfficerIdDocument(
    applicationId: string,
    officerId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Application/{applicationId}/officers/{officerId}/id-document',
      path: {
        'applicationId': applicationId,
        'officerId': officerId,
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Stream a business officer's ID document for preview or download.
   * @param applicationId
   * @param officerId
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadBusinessOfficerIdDocument(
    applicationId: string,
    officerId: string,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Application/{applicationId}/officers/{officerId}/id-document/content',
      path: {
        'applicationId': applicationId,
        'officerId': officerId,
      },
      query: {
        'download': download,
      },
    });
  }
}
